import { Button, Checkbox, Spinner } from '@acpaas-ui/react-components';
import { INPUT_STATES } from '../../../components/forms/forms.utils';
import Radio from '../../../components/forms/Radio';
import TextField from '../../../components/forms/TextField';
import {
  ADMIN_CONTACT_CITY,
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_SCHOOL,
  ADMIN_CONTACT_TYPES
} from '../../../constants/admin.contacts.constants';
import { TERMS_AND_CONFIDENTIALITY_LINK } from '../../../constants/settings.constants';
import FirstTimePartnerOptions from './FirstTimePartnerOptions';
import FirstTimeSchoolOptions from './FirstTimeSchoolOptions';

const FirstTimeForm = ({
  hideTypeSelection,
  data,
  onInput,
  onEmailInput,
  submitting,
  emailValidation,
  submitError,
  organizations,
  nets,
  schools,
  schoolsData,
  branchesData,
  onNetChange,
  onSchoolChange,
  onBranchChange,
  onOrganizationChange,
  onTypeChange,
  canConfirm,
  onConfirm
}) => {
  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-lg-8 u-margin-bottom-md">
          <TextField
            state={INPUT_STATES.DEFAULT}
            value={data?.firstName}
            name={'firstName'}
            onChange={(value) => onInput(value, 'firstName')}
            label="Voornaam"
            disabled={submitting}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8 u-margin-bottom-md">
          <TextField
            state={INPUT_STATES.DEFAULT}
            value={data?.lastName}
            onChange={(value) => onInput(value, 'lastName')}
            label="Achternaam"
            disabled={submitting}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8 u-margin-bottom-md">
          <TextField
            state={INPUT_STATES.DEFAULT}
            value={data?.email}
            onChange={onEmailInput}
            label="E-mail adres"
            hasError={!!emailValidation}
            validationError={emailValidation}
            disabled={submitting}
            required
          />
        </div>
      </div>
      {!hideTypeSelection && (
        <div className="row">
          <div className="col-xs-12 col-lg-8 u-margin-bottom-md">
            <Radio
              name="type"
              value={data?.type}
              onChange={onTypeChange}
              label="Ik ga dit platform gebruiken als:"
              options={ADMIN_CONTACT_TYPES.filter((t) => t.value !== ADMIN_CONTACT_CITY)}
              disabled={submitting}
              required
            />
          </div>
        </div>
      )}
      {data?.type && (
        <div className="row">
          <div className="col-xs-12 col-lg-8 u-margin-bottom-lg">
            {data.type === ADMIN_CONTACT_PARTNER && (
              <FirstTimePartnerOptions
                data={data}
                onOrganizationChange={onOrganizationChange}
                isLoadingOrganizations={organizations.isLoading}
                organizations={organizations.options}
                disabled={submitting}
              />
            )}
            {data.type === ADMIN_CONTACT_SCHOOL && (
              <FirstTimeSchoolOptions
                data={data}
                onChange={onInput}
                onNetChange={onNetChange}
                onSchoolChange={onSchoolChange}
                onBranchChange={onBranchChange}
                isLoadingNets={nets.isLoading}
                nets={nets.options}
                netsLoadError={nets.loadError}
                isLoadingSchools={schools.isLoading}
                schools={schoolsData?.map((school) => ({ ...school, value: school.id, label: school.name }))}
                schoolsLoadError={schools.loadError}
                isLoadingBranches={schools.isLoading}
                branches={branchesData?.map((b) => ({ ...b, value: b.id, label: b.name }))}
                branchesLoadError={schools.loadError}
                disabled={submitting}
              />
            )}
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-lg-8 u-margin-bottom-lg">
          <Checkbox
            value={data?.acceptPrivacy}
            onChange={() => onInput(!data?.acceptPrivacy, 'acceptPrivacy')}
            label={
              <span>
                Ik heb de{' '}
                <a href={TERMS_AND_CONFIDENTIALITY_LINK} target="_blank" rel="noreferrer">
                  algemene voorwaarden en confidentialiteitsverklaring
                </a>{' '}
                gelezen en goedgekeurd
              </span>
            }
            required
            disabled={submitting}
          />
        </div>
      </div>
      <Button className="u-margin-bottom-lg" disabled={submitting || !canConfirm} onClick={onConfirm}>
        Ga naar het platform
      </Button>
      {submitting && <Spinner />}
      {submitError && <p className="u-text-danger">{submitError}</p>}
    </div>
  );
};

export default FirstTimeForm;
